export enum Product {
    TopUp = 'topUp',
    SellProduct = 'sellProduct',
    SellCard = 'sellCard',
    RegisterCard = 'registerCard',
}
